import React, { Component } from 'react';
import './index.scss';
import SvgZoomMap from '../../utils/SvgZoomMap';
import LoadingDots from '../../utils/LoadingDots';
import Axios from 'axios';
import { apiHost, loginApiHost } from '../../utils/Shared/constant';
import { transferHundredPoint } from '../../utils/Shared/methods';

class EvacuationShelterMap extends Component {
	constructor(params) {
		super(params);
		this.mapWrap = React.createRef();
		this.state = {
			isMapShow: false,
			isBubbleShow: false,
			bubble: {
				name: null,
				avarge: null,
				sum: null,
				event: null,
				count: null
			},
			bubbleTop: 0,
			bubbleLeft: 0,
			county: '',
			town: '',
			village: '',
			villageSrc: 'taiwan-village.json',
			gap: 6,
			colorSet: [
				{ unit: "人次", gap: 6, colors: ['#FBE9F2', '#EEE0F4', '#D0D1E6', '#A6BDDB', '#67AACF', '#3690C0', '#337BB6'] },
				{ unit: "次數", gap: 7, colors: ['#FCF0B7', '#FCE298', '#FCC779', '#FDAC6F', '#FC8063', '#E75858', '#C84864', '#A73B58'] },
			],
			colors: [],
			curcolors: [],
			ranges: [],
		};
	}
	componentDidMount() {
		this.getVersion();
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps !== this.props) {			
			this.handleGetShelterLocate();
			this.getRanges();
			if (prevProps.shelters) {
				if (prevProps.shelters.county !== this.props.shelters.county ||
					prevProps.shelters.town !== this.props.shelters.town ||
					prevProps.shelters.village !== this.props.shelters.village) {
					this.handleCloseBubble();
				}
			}
		}
	}

	getVersion() {
		Axios.get(
			`${apiHost}/api/ShelterInfo/GetVersion`
		).then((res) => {
			this.setState({ villageSrc: res.data.version })
		})
	}


	getRanges() {
		const { evacuationData } = this.props;

		const { shelters } = this.props;
		if (shelters && shelters.village) {
			this.setState({ mapData: null, ranges: null, colorBar: '' });
			return;
		}
		if (evacuationData != null) {
			const { unit, transferValue } = evacuationData;
			const set = this.state.colorSet.find(item => item.unit === unit);
			const { gap, colors } = set;
			const maximum = Math.max(...evacuationData.data.map(data => data[transferValue]));
			const minimum = Math.min(...evacuationData.data.map(data => data[transferValue]));
			const isVillageLevel = evacuationData.county !== '' && evacuationData.town !== '';
			const dataGap = (maximum - minimum) <= gap * 2
				? (isVillageLevel
					? Math.max(Math.min(Math.floor(maximum - minimum), colors.length - 1), 1)
					: Math.max(Math.floor((maximum - minimum) / 2), 1))
				: gap;
			const min = (maximum - minimum) / dataGap;
			const digits = Math.ceil(min).toString().length - 1;
			let delta;
			const base = Math.floor(minimum / Math.pow(10, digits)) * Math.pow(10, digits);
			if (digits <= 1) { delta = Math.ceil(min) };
			if (digits > 1) { delta = Math.ceil(min / Math.pow(10, digits)) * Math.pow(10, digits) };
			const allDataIsNull = evacuationData.data.every(data => data[transferValue] === null);
			const ranges = [];
			for (let i = 0; i < dataGap - 1; i++) {
				ranges.push(base + (delta * (i + 1)));
			};
			ranges.push(maximum);
			this.setState({
				unit: unit,
				colors: colors,
				ranges: ranges,
				rangeBase: base,
				isColorMarkHide: allDataIsNull,
				zeroPositionPercent: Math.abs((minimum / (maximum - minimum) * 100)),
			}, () => this.handleLoadData());
		}
	}
	handleLoadData = () => {
		const { evacuationData } = this.props;
		const { transferValue } = evacuationData;
		const { colors } = this.state;
		if (evacuationData) {
			const { county, town } = evacuationData;
			const mapData = {
				layer: '',
				data: []
			};			
			if (county === '' && town === '') {
				mapData.layer = 'county';
			}
			else if (county !== '' && town === '') {
				mapData.layer = 'town';
			}
			else {
				mapData.layer = 'village';
			}

			evacuationData.data.forEach(item => {
				const obj = {};
				obj.name = item.Name;
				obj.attribute = {
					'style': {
						'fill': this.handleTransferColor(item[transferValue]),
						'stroke': '#555555',
					},
					'data-sum': item.Value,
				}
				mapData.data.push(obj);
			});

			this.setState({
				mapData: mapData,
				county: county,
				town: town,
			}, () => { this.getColorBar(colors) })
		}
	}
	handleTransferColor = (value) => {
		const { ranges, colors } = this.state;
		let color;
		for (let i = 0; i < ranges.length; i++) {
			if (value >= ranges[i] && value < ranges[i + 1]) {
				color = colors[i + 1];
			}
		}
		if (value <= ranges[0]) {
			color = colors[0];
		}
		if (value >= ranges[ranges.length - 1]) {
			color = colors[ranges.length];
		}
		if (value === 0) {
			color = '#eee';
		}
		return color;
	}
	handleMouseOverMap = (area, e) => {
		this.setState({
			isBubbleShow: true,
			bubbleTop: e.clientY,
			bubbleLeft: e.clientX,			
			bubble: {
				name: e.target.dataset.name || area.filter(_ => _).slice(-1),				
				value: e.target.dataset.sum  || null,
			},
		})
	}

	handleMouseLeaveMap = () => {						
		this.setState({
			isBubbleShow: false,
		})
	}

	getColorBar = (colorSet) => {
		const { mapData } = this.state;
		let colorBar = ''
		let maxIndex = this.getMaxColorIndex(mapData.data, colorSet);
		let endIndex = maxIndex
		if (endIndex === 1) { endIndex++; }
		colorBar = colorSet.slice(0, endIndex).join(',');
		this.setState({ colorBar })
	}

	getMaxColorIndex = (data, colorSet) => {
		let maxIndex = 0;
		data.forEach(item => {
			let colorCode = item.attribute.style.fill;
			let index = colorSet.indexOf(colorCode);
			if (maxIndex < index) {
				maxIndex = index;
			}
		})
		return maxIndex + 1;
	}

	handleGetShelterLocate() {
		const { shelters, isShelterMark } = this.props;
		if (shelters) {
			const sheltersLocate = shelters.data.map((shelter, i) => {
				return {
					id: i,
					shelter_id:shelter['shelter_id'],
					title: shelter['shelter_name'],
					active: shelter.active,
					location: [Number(shelter['latitude']), Number(shelter['longitude'])]
				}				
			})			
			this.setState({
				// isBubbleShow: false,
				isBubbleShow: isShelterMark,
				sheltersLocate: sheltersLocate,
				county: shelters.county,
				town: shelters.town,
				village: shelters.village,
			},
				// () => this.handleGetShelterDomPosition() 
			);
		}
	}
	// handleGetShelterDomPosition() {
	// 	const { sheltersLocate } = this.state;
	// 	const pinDom = document.querySelector('.pin.-active');
	// 	if (pinDom) {
	// 		const { shelters } = this.props;
	// 		const index = sheltersLocate.findIndex(shelter => shelter.active);
	// 		const posX = pinDom.getBoundingClientRect().left;
	// 		const posY = pinDom.getBoundingClientRect().top;

	// 		this.setState({
	// 			isBubbleShow: true,
	// 			bubble: shelters.data[index],
	// 		}, () => this.handlePinPosition(posX, posY));
	// 	}
	// }


	handlePinClick = (pin, e) => {
		const index = pin.id;
		const clientX = e.clientX;
		const clientY = e.clientY;
		this.props.handlePinClick(pin);

		const { shelters } = this.props;
		this.handlePinPosition(shelters.data[index], clientX, clientY);
	}
	handlePinPosition = (data, clientX, clientY) => {
		const mapWrap = this.mapWrap.current;
		const boxWidth = 350;
		const boxHeight = 450;
		const posX = clientX - mapWrap.getBoundingClientRect().x;
		const posY = clientY - mapWrap.getBoundingClientRect().y;

		this.setState({
			isBubbleShow: true,
			bubble: data,
			bubbleTop: posY,
			bubbleLeft: posX,
			bubbleOppositeX: (clientX + boxWidth) > window.innerWidth,
			bubbleOppositeY: (window.scrollY + clientY + boxHeight) > document.body.offsetHeight
		})
	}
	handleCloseBubble = () => {
		this.props.handleCloseBubble();
		this.setState({ isBubbleShow: false })
	}
	transferValue(value) {
		return (value === '' || value === 0) ? '-' : value;
	}
	// 含數值下載：清除、初始化、加文字（同 EvacuationChartMap 的做法）
	MapTextRest = () => {
		const mapNames = document.querySelector('#svgMapShelter .map-names');
		if (mapNames) { mapNames.innerHTML = ''; }
	}
	MapTextInit = () => {
		this.MapTextRest();
		this.AppendName();
	}
	AppendName = () => {
		const towns = document.querySelectorAll('#svgMapShelter g .-town');
		const mapNames = document.querySelector('#svgMapShelter .map-names');
		if (!mapNames || towns.length === 0) return;
		const svg = document.querySelector('#svgMapShelter');
		if (!svg) return;
		const vbWidth = svg.viewBox.baseVal.width;
		const width = svg.getAttribute('width');
		const scaleNum = vbWidth / width;
		const fontSize = 15 * scaleNum;
		towns.forEach((item) => {
			const rect = item.getBBox();
			const cx = rect.x + rect.width * 0.5;
			const cy = rect.y + rect.height * 0.5;
			const textEl = document.createElementNS("http://www.w3.org/2000/svg", "text");
			textEl.setAttribute("x", cx);
			textEl.setAttribute("y", cy);
			textEl.setAttribute("dominant-baseline", "middle");
			textEl.setAttribute("text-anchor", "middle");
			textEl.setAttribute("font-size", fontSize);
			textEl.setAttribute("font-weight", "bold");
			const tName = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
			tName.textContent = item.querySelector('town').textContent;
			tName.setAttribute("x", cx);
			tName.setAttribute("dy", "-1em");
			const tValue = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
			const val = item.querySelector('path').getAttribute('data-sum');
			tValue.textContent = val !== null ? val : '查無資料';
			tValue.setAttribute("x", cx);
			tValue.setAttribute("dy", "1em");
			textEl.appendChild(tName);
			textEl.appendChild(tValue);
			mapNames.appendChild(textEl);
		});
	}
	render() {
		const { isMemberLogin } = this.props;
		const { sheltersLocate } = this.state;
		const { isMapShow, isBubbleShow, bubble, bubbleTop, bubbleLeft, bubbleOppositeX, bubbleOppositeY } = this.state;
		const { county, town, village } = this.state;
		const { villageSrc } = this.state;
		const { mapData, ranges, unit, colorBar, zeroPositionPercent } = this.state;
		return (
			<div className="shelter-map" ref={this.mapWrap}>
				{town && village &&
				<div className={`bubble-info ${isBubbleShow ? '-show' : ''}`}
					style={{
						'position': 'absolute',
						'top': `${bubbleTop}px`,
						'left': `${bubbleLeft}px`,
						'zIndex': 99
					}}>
					<div className={`bubble ${bubbleOppositeX ? '-left' : '-right'} ${bubbleOppositeY ? '-top' : '-bottom'}`}>
						<button className="close" onClick={this.handleCloseBubble}><i className="icon-close"></i></button>
						<h3 className="shelter__title">{bubble.shelter_name}</h3>

						{bubble['shelter_id'] ? <dl className="shelter-detail-dl"><dt>災民收容所編號</dt><dd>{this.transferValue(bubble['shelter_id'])}</dd></dl> : ''}
						{bubble['shelter_name'] ? <dl className="shelter-detail-dl"><dt>災民收容所名稱</dt><dd>{this.transferValue(bubble['shelter_name'])}</dd></dl> : ''}
						{bubble['management_level'] ? <dl className="shelter-detail-dl"><dt>管理層級</dt><dd>{this.transferValue(bubble['management_level'])}</dd></dl> : ''}
						{bubble['shelter_address'] ? <dl className="shelter-detail-dl"><dt>收容所地址</dt><dd>{this.transferValue(bubble['shelter_address'])}</dd></dl> : ''}
						{bubble['serve_village'] ? <dl className="shelter-detail-dl"><dt>服務里別</dt><dd>{this.transferValue(bubble['serve_village'])}</dd></dl> : ''}
						{bubble['shelter_inside_count'] ? <dl className="shelter-detail-dl"><dt>室內可收容人數</dt><dd>{this.transferValue(bubble['shelter_inside_count'])}</dd></dl> : ''}
						{bubble['shelter_outside_count'] ? <dl className="shelter-detail-dl"><dt>室外可收容人數</dt><dd>{this.transferValue(bubble['shelter_outside_count'])}</dd></dl> : ''}
						{bubble['shelter_count'] ? <dl className="shelter-detail-dl"><dt>可收容人數總計</dt><dd>{this.transferValue(bubble['shelter_count'])}</dd></dl> : ''}
						{bubble['shelter_area'] ? <dl className="shelter-detail-dl"><dt>室內容納面積(平方公尺)</dt><dd>{this.transferValue(bubble['shelter_area'])}</dd></dl> : ''}
						{bubble['for_weak'] ? <dl className="shelter-detail-dl"><dt>適合避難弱者安置</dt><dd>{this.transferValue(bubble['for_weak'])}</dd></dl> : ''}
						{bubble['for_disaster'] ? <dl className="shelter-detail-dl"><dt>適用災別</dt><dd>{this.transferValue(bubble['for_disaster'])}</dd></dl> : ''}
						{bubble['shelter_feature'] ? <dl className="shelter-detail-dl"><dt>空間特性</dt><dd>{this.transferValue(bubble['shelter_feature'])}</dd></dl> : ''}
						{bubble['contact_name'] ? <dl className="shelter-detail-dl"><dt>聯絡人姓名</dt><dd>{this.transferValue(bubble['contact_name'])}</dd></dl> : ''}
						{bubble['contact_tel'] ? <dl className="shelter-detail-dl"><dt>聯絡人電話</dt><dd>{this.transferValue(bubble['contact_tel'])}</dd></dl> : ''}
						{bubble['contact_mobile'] ? <dl className="shelter-detail-dl"><dt>聯絡人手機號碼</dt><dd>{this.transferValue(bubble['contact_mobile'])}</dd></dl> : ''}
						{bubble['manage_department'] ? <dl className="shelter-detail-dl"><dt>收容所管理單位</dt><dd>{this.transferValue(bubble['manage_department'])}</dd></dl> : ''}
						{bubble['mange_name'] ? <dl className="shelter-detail-dl"><dt>管理人姓名</dt><dd>{this.transferValue(bubble['mange_name'])}</dd></dl> : ''}
						{bubble['mange_tel'] ? <dl className="shelter-detail-dl"><dt>管理人電話</dt><dd>{this.transferValue(bubble['mange_tel'])}</dd></dl> : ''}
						{bubble['mange_mobile'] ? <dl className="shelter-detail-dl"><dt>管理人手機號碼</dt><dd>{this.transferValue(bubble['mange_mobile'])}</dd></dl> : ''}
						{bubble['longitude'] && isMemberLogin ? <dl className="shelter-detail-dl"><dt>TWD97 X軸</dt><dd>{this.transferValue(bubble['longitude'])}</dd></dl> : ''}
						{bubble['latitude'] && isMemberLogin ? <dl className="shelter-detail-dl"><dt>TWD97 Y軸</dt><dd>{this.transferValue(bubble['latitude'])}</dd></dl> : ''}
						{bubble['notice'] ? <dl className="shelter-detail-dl"><dt>備註</dt><dd>{this.transferValue(bubble['notice'])}</dd></dl> : ''}
						{!isMemberLogin ? <p className="value">（欲查看收容所聯絡方式，請先登入會員）</p> : ''}
					</div>
				</div>
}
				{(!town || !village) &&
				<div className={`bubble-info-count ${isBubbleShow ? '-show' : ''}`}
					style={{
						'position': 'fixed',
						'top': `${bubbleTop}px`,
						'left': `${bubbleLeft}px`,
						'zIndex': 99
					}}>
						<div className="bubble">
							<p className="name">{ bubble.name }</p>							
							{ bubble.value    && <p className="value">個數 { transferHundredPoint(bubble.value) }</p> }							
							{
								!bubble.value &&
								<p className="value">查無資料</p>
							}
						</div>
					</div>
				}

				<div className='capture'>
					{ranges &&
						<div className="range-mark">
							<div className="title">個數</div>
							{
								<React.Fragment>
									<div className="range-noData">
										<div className="colorBar" />
										<div className="value">查無資料</div>
									</div>
									<div className="range">
										<div className="colorBar" style={{ background: `linear-gradient(${colorBar})` }}></div>
										<div className="valueBar">
											<div className="value type-text -en">0</div>
											<div className="value type-text -en zero" style={{ top: `${zeroPositionPercent}%` }}></div>
											<div className="value type-text -en buttom">{ranges[ranges.length - 1]}</div>
										</div>
									</div>
								</React.Fragment>
							}
						</div>
					}
				</div>

				{!isMapShow && <LoadingDots theme="red" />}
				<div className={`taiwan-map ${isMapShow && '-show'}`} 
				onMouseLeave={(!town || !village) ? this.handleMouseLeaveMap:null}>
					<SvgZoomMap
						countyJsonSrc="/MapJson/taiwan-county.json"
						townJsonSrc="/MapJson/taiwan-town.json"
						villageJsonSrc={`${loginApiHost}/Admin/Files/TopoJson/${villageSrc}`}
						onAreaHover={(!town || !village)?this.handleMouseOverMap:null}
						enableHighlightBorder={!!town}
						county={county}
						town={town}
						village={village}
						pins={!town ? null : sheltersLocate}
						onCloseButtonClick={this.handleCloseBubble}
						onPinClick={(pinItem, e) => { this.handlePinClick(pinItem, e) }}
						handlePinClick={this.handlePinClick}
						isMapInit={() => { this.setState({ isMapShow: true }) }}
						infoData={mapData}
					/>
				</div>

				{/* 隱藏的含數值地圖（永遠渲染，避免 race condition） */}
				<div className="captureText captureText-hidden" style={{position:'absolute', top: '-9999px', width: '100%'}}>
					{ranges &&
						<div className="range-mark">
							<div className="title">個數</div>
							<React.Fragment>
								<div className="range-noData">
									<div className="colorBar" />
									<div className="value">查無資料</div>
								</div>
								<div className="range">
									<div className="colorBar" style={{ background: `linear-gradient(${colorBar})` }}></div>
									<div className="valueBar">
										<div className="value type-text -en">0</div>
										<div className="value type-text -en zero" style={{ top: `${zeroPositionPercent}%` }}></div>
										<div className="value type-text -en buttom">{ranges[ranges.length - 1]}</div>
									</div>
								</div>
							</React.Fragment>
						</div>
					}
					<div className={`taiwan-map ${isMapShow && '-show'}`}>
						<SvgZoomMap
							svgId="svgMapShelter"
							countyJsonSrc="/MapJson/taiwan-county.json"
							townJsonSrc="/MapJson/taiwan-town.json"
							villageJsonSrc={`${loginApiHost}/Admin/Files/TopoJson/${villageSrc}`}
							county={county}
							town={town}
							infoData={mapData}
							zoomDelay={0}
							isMapInit={() => {}}
							isMapUpdate={() => { this.MapTextInit(); }}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default EvacuationShelterMap;
